import { render, staticRenderFns } from "./email_folder_panel.vue?vue&type=template&id=58a43782&"
import script from "./email_folder_panel.vue?vue&type=script&lang=js&"
export * from "./email_folder_panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58a43782')) {
      api.createRecord('58a43782', component.options)
    } else {
      api.reload('58a43782', component.options)
    }
    module.hot.accept("./email_folder_panel.vue?vue&type=template&id=58a43782&", function () {
      api.rerender('58a43782', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/mailboxer/email_folder_panel.vue"
export default component.exports